<template>
  <div id="criar-conta-parceiro">
    <ValidationObserver ref="observer" class="row">
      <div class="container">
        <div class="row">
          <div class="offset-md-1 col-md-10 col-12">
            <pulse-loader
              :loading="loading"
              :color="color"
              :size="size"
              class="vue-loader"
            ></pulse-loader>
            <div class="card-criar-conta">
              <div class="loader"></div>
              <div class="card-criar-conta-title">
                <div class="col-md-12">
                  <div class="section-title-btn-help">
                    <ModalInfo modalDocument="DocCadastro" />
                  </div>
                </div>
                <h2>Cadastre-se</h2>
                <p>
                  Crie sua conta para acessar os recursos que o sistema oferece
                  de acordo o seu perfil profissional
                </p>
              </div>
              <div class="row">
                <div class="col-md-4 col-12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="error">{{ errors[0] }}</div>
                    <div class="form-group input-group">
                      <vue-select
                        :options="estados"
                        label="uf"
                        placeholder="ESTADO"
                        @input="onChangeEstados"
                        v-model="estado"
                        class="vue-select-estado"
                      >
                        <div slot="no-options">
                          Não há opções correspondentes
                        </div>
                      </vue-select>
                    </div>
                  </validation-provider>
                </div>
                <div class="col-md-8 col-12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="error">{{ errors[0] }}</div>
                    <div class="form-group input-group">
                      <vue-select
                        :options="cidades"
                        label="no_municipio"
                        placeholder="CIDADE DE TRABALHO"
                        v-model="cidade"
                        class="vue-select-cidade"
                      >
                        <template slot="option" slot-scope="option">
                          {{ option.no_municipio }}
                        </template>
                        <div slot="no-options">
                          Não há opções correspondentes
                        </div>
                      </vue-select>
                    </div>
                  </validation-provider>
                </div>
                <div class="col-md-4 col-12">
                  <validation-provider v-slot="{ errors }" rules="required|cpf">
                    <div class="error">{{ errors[0] }}</div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="icofont-card"></i>
                        </span>
                      </div>
                      <the-mask
                        v-model="cpf"
                        :mask="['###.###.###-##']"
                        class="cpf form-control"
                        placeholder="CPF"
                        required
                      />
                      <!-- @blur.native="onBlurCpf($event)" -->
                    </div>
                  </validation-provider>
                </div>
                <div class="col-md-8 col-12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="error">{{ errors[0] }}</div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="icofont-ui-user"></i>
                        </span>
                      </div>
                      <select
                        class="form-control"
                        @change="onChangeFuncao($event)"
                        v-model="funcao"
                        name="funcao"
                        required
                        :disabled="disabledInputFuncao == true"
                      >
                        <option value="" disabled>PERFIL</option>
                        <option value="Gerente/Coordenador(a)">
                          Gerente/Coordenador(a)
                        </option>
                        <option value="Secretário(a)">Secretário(a)</option>
                        <option value="Agente Comunitário de Saúde">
                          Agente Comunitário de Saúde (ACS)
                        </option>
                        <option value="Aux/Téc Enfermagem">
                          Aux/Téc Enfermagem
                        </option>
                        <option value="Enfermeiro(a)">Enfermeiro(a)</option>
                        <option value="Médico(a)">Médico(a)</option>
                        <option value="Odontólogo(a)">Odontólogo(a)</option>
                        <option value="Recepcionista">Recepcionista</option>
                        <option value="Agente Comunitário de Endemias (ACE)">
                          Agente Comunitário de Endemias (ACE)
                        </option>
                        <option value="Coordenador(a) de Vigilância em Saúde">
                          Coordenador(a) de Vigilância em Saúde
                        </option>
                        <option value="Coordenador(a) de Imunização">
                          Coordenador(a) de Imunização
                        </option>
                        <option value="Vacinador(a)">Vacinador(a)</option>
                        <option value="Téc. Aux de Saúde Bucal">
                          Téc. Aux de Saúde Bucal
                        </option>
                        <option value="Profissional da eMulti">
                          Profissional da eMulti
                        </option>
                      </select>
                    </div>
                  </validation-provider>
                </div>
                <div class="row px-3">
                  <div class="col-md-8 col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|name"
                    >
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="icofont-ui-user"></i>
                          </span>
                        </div>
                        <input
                          name="nome"
                          v-model="nome"
                          class="form-control"
                          placeholder="NOME COMPLETO"
                          type="text"
                          required
                          :disabled="disabledInput == true"
                        />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-md-4 col-12">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="icofont-ui-user"></i>
                          </span>
                        </div>
                        <input
                          name="data_nascimento"
                          v-model="data_nascimento"
                          class="form-control"
                          placeholder="Data de nascimento"
                          type="text"
                          onfocus="(this.type='date')"
                          required
                        />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-md-4 col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|email"
                    >
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="icofont-envelope"></i>
                          </span>
                        </div>
                        <input
                          name="email"
                          v-model="email"
                          class="form-control"
                          placeholder="E-MAIL"
                          type="email"
                        />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-md-4 col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|phone"
                    >
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="icofont-phone"></i>
                          </span>
                        </div>
                        <the-mask
                          :mask="['(##) ####-####', '(##) #####-####']"
                          v-model="telefone"
                          required
                          class="form-control"
                          placeholder="TELEFONE"
                        />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-md-6 col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|password"
                    >
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div
                          class="input-group-prepend"
                          @click="showPassword = !showPassword"
                          style="cursor: pointer"
                        >
                          <span class="input-group-text">
                            <i
                              :class="
                                showPassword
                                  ? 'icofont-eye-blocked'
                                  : 'icofont-eye'
                              "
                            ></i>
                          </span>
                        </div>
                        <input
                          name="senha"
                          v-model="senha"
                          class="form-control"
                          placeholder="SENHA"
                          :type="showPassword ? 'text' : 'password'"
                          required
                        />
                      </div>
                      <div class="mt-2 mb-2">
                        <ul>
                          <li :class="colorLenght">
                            <i :class="lenghtPassword"></i> 8 ou mais
                            caracteres;
                          </li>
                          <li :class="colorLetters">
                            <i :class="lettersPassword"></i> 1 ou mais letras
                            maiúsculas;
                            <span
                              v-b-tooltip.hover
                              title="A B C D E F G H I J K L M N O P Q R S T U V W X Y Z"
                              class="icon-tooltip"
                            >
                              <i class="icofont-info-circle"></i>
                            </span>
                          </li>
                          <li :class="colorNumbers">
                            <i :class="numbersPassword"></i> 1 ou mais números;
                            <span
                              v-b-tooltip.hover
                              title="1 2 3 4 5 6 7 8 9 0"
                              class="icon-tooltip"
                            >
                              <i class="icofont-info-circle"></i>
                            </span>
                          </li>
                          <li :class="colorSpecialChars">
                            <i :class="SpecialCharsPassword"></i> 1 ou mais
                            caracteres especiais.
                            <span
                              v-b-tooltip.hover
                              title="Exemplos de caracteres especiais: ! @ # $ % ^ & * ( ) _ + \ - = [ \ ] { } ; : \ \ | , . < > / ? ~"
                              class="icon-tooltip"
                            >
                              <i class="icofont-info-circle"></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-md-6 col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|password"
                    >
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div
                          class="input-group-prepend"
                          @click="
                            showConfirmedPassword = !showConfirmedPassword
                          "
                        >
                          <span class="input-group-text">
                            <i
                              :class="
                                showConfirmedPassword
                                  ? 'icofont-eye-blocked'
                                  : 'icofont-eye'
                              "
                            ></i>
                          </span>
                        </div>
                        <input
                          name="senha"
                          v-model="confirmarsenha"
                          class="form-control"
                          placeholder="CONFIRMAR SENHA"
                          :type="showConfirmedPassword ? 'text' : 'password'"
                          required
                        />
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-12">
                    <div
                      class="d-flex flex-column align-items-center justify-content-center mb-4"
                    >
                      <span class="mb-2">Foto do perfil (opcional)</span>

                      <div class="avatar-wrapper" @click="triggerAvatarSelect">
                        <div class="avatar-uploader">
                          <img
                            v-if="avatarPreview"
                            :src="avatarPreview"
                            alt="Foto do perfil"
                            class="avatar-img"
                          />
                          <div v-else class="avatar-placeholder">
                            <i class="icofont-ui-user"></i>
                            <small>Foto</small>
                          </div>
                        </div>

                        <!-- badge câmera -->
                        <div class="avatar-badge">
                          <i class="icofont-camera"></i>
                        </div>

                        <!-- botão remover (só quando tem foto) -->
                        <button
                          v-if="avatarPreview"
                          type="button"
                          class="avatar-remove"
                          @click.stop="removerAvatar"
                          aria-label="Remover foto"
                          title="Remover foto"
                        >
                          <i class="icofont-close"></i>
                        </button>
                      </div>

                      <input
                        ref="avatarInput"
                        type="file"
                        accept="image/*"
                        class="d-none"
                        @change="onAvatarSelected"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{ required: { allowFalse: false } }"
                    >
                      <div class="error">{{ errors[0] }}</div>
                      <div class="form-group input-group">
                        <div class="checkbox">
                          <input
                            type="checkbox"
                            value=""
                            v-model="isChecked"
                            required
                          />
                          Li e estou de acordo com os
                          <span @click="showModal = true">Termos de uso.</span>
                        </div>
                      </div>
                    </validation-provider>
                    <ModalTermos
                      v-if="showModal"
                      @close-modal-termos="closeModalTermos()"
                      @aceitar-termos="aceitarTermos()"
                    >
                    </ModalTermos>
                  </div>
                  <div class="col-12">
                    <vue-recaptcha
                      @verify="onVerify"
                      sitekey="6Lc2rcMZAAAAAEajREawZOuLW75FAAm8cGWfnFti"
                    >
                    </vue-recaptcha>
                  </div>
                  <div class="col-12 mt-3">
                    <button
                      type="submit"
                      class="btn"
                      v-bind:disabled="btnDisable"
                      v-on:click="cadastrar()"
                    >
                      Cadastrar
                    </button>
                  </div>
                </div>
                <!-- <div
                  v-if="temEsusFeedback == false"
                  class="error-esus-feedback"
                >
                  <h3>Ops... <i class="icofont-sad"></i></h3>
                  <h4>Essa cidade ainda não possui eSUS Feedback.</h4>
                  <p>
                    {{ nome }}, por gentileza, indica o eSUS Feedback para o seu
                    Coordenador(a) e Secretário(a) de Saúde. Nossa equipe
                    gostaria de apoiar vocês no acompanhamento dos Indicadores
                    do Previne Brasil.
                  </p>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-center">
              <router-link to="/login">
                <button class="btn">
                  <i class="icofont-arrow-left"></i> Voltar
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <b-modal
      v-model="modalInfoMunicipio.active"
      title="Atenção!"
      centered
      hide-footer
    >
      <strong>{{ modalInfoMunicipio.text }}</strong>
    </b-modal>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import ModalTermos from '../../components/ModalTermos'
import { TheMask } from 'vue-the-mask'
import ModalInfo from '@/components/ModalInfo'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  components: {
    ModalTermos,
    'vue-recaptcha': VueRecaptcha,
    TheMask,
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    ModalInfo,
  },
  metaInfo: {
    title: 'Criar conta',
    titleTemplate: null,
  },
  data() {
    return {
      data: '',
      estado: '',
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SE' },
        { uf: 'TO' },
      ],
      cidade: '',
      cidades: [],
      nome: '',
      cpf: '',
      email: '',
      funcao: '',
      funcoes: [],
      data_nascimento: '',
      telefone: '',
      senha: '',
      confirmarsenha: null,
      avatarFile: null,
      avatarPreview: null,
      status: {
        error: false,
        message: '',
      },
      toastClass: '',
      isChecked: '',
      btnDisable: true,
      visibleInputEmail: true,
      robot: false,
      showModal: false,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      temEsusFeedback: null,
      disabledInput: false,
      disabledInputFuncao: false,
      modalInfoMunicipio: {
        active: false,
        text: '',
      },
      showPassword: false,
      showConfirmedPassword: false,
    }
  },
  computed: {
    colorLenght() {
      if (this.senha.length < 8) {
        return 'red'
      }
      return 'green'
    },
    lenghtPassword() {
      if (this.senha.length < 8) {
        return 'icofont-close'
      }
      return 'icofont-check'
    },
    colorNumbers() {
      if (/\d/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    numbersPassword() {
      if (/\d/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorLetters() {
      if (/[A-Z]/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    lettersPassword() {
      if (/[A-Z]/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorSpecialChars() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    SpecialCharsPassword() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
  },
  watch: {
    isChecked(value) {
      if (value) {
        this.btnDisable = false
      } else {
        this.btnDisable = true
      }
    },
  },
  methods: {
    /**
     * Habilita o checkbox dos termos de uso
     */
    aceitarTermos() {
      this.showModal = false
      this.isChecked = 'checked'
      this.btnDisable = false
    },

    /**
     * Fecha o modal termos de uso
     */
    closeModalTermos() {
      this.showModal = false
      this.isChecked = ''
      this.btnDisable = true
    },

    /**
     * Manipula a alteração do estado selecionado
     *
     * @param {Object} event
     */
    onChangeEstados(event) {
      this.loading = true
      this.limpaCampos()
      let estado = event.uf
      this.$apiPublic
        .get(`/estados/${estado}/cidades`)
        .then((response) => {
          this.cidades = response.data
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    // onChangeCidades(event) {
    //   this.limpaCampos()
    //   // this.cidade = event.co_ibge
    // },

    /**
     * Manipula a alteração da função selecionada
     *
     * @param {Object} event
     */
    async onChangeFuncao(event) {
      this.funcao = event.target.value
      if (
        this.funcao != 'Gerente/Coordenador(a)' &&
        this.funcao != 'Secretário(a)'
      ) {
        if (this.cidade != '') {
          const response = await this.$apiPublic.get(
            '/faturamento/cidade/' + this.cidade.co_ibge
          )
          if (response.data == false) {
            this.modalInfoMunicipio.active = true
            this.modalInfoMunicipio.text = `A gestão municipal de saúde de ${this.cidade.no_municipio} - ${this.estado.uf}, ainda não tem licença de uso desse sistema para ofertar a você. Você pode fazer seu cadastro, mas precisa da licença adquirida pela gestão municipal para fazer uso das funcionalidades.`
          } else {
            if (response.data.status == '1') {
              this.modalInfoMunicipio.active = false
              this.modalInfoMunicipio.text = ''
            } else {
              this.modalInfoMunicipio.active = true
              this.modalInfoMunicipio.text = `Estamos em negociação ou renegociação de licenciamento deste software com a gestão municipal de saúde de ${this.cidade.no_municipio} - ${this.estado.uf}. Você pode efetuar o cadastro, mas o mesmo ficará inativo até que este processo seja concluído.`
            }
          }
        }
      }
    },

    /**
     * Valida um CPF
     *
     * @param {String} cpf
     */
    validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf == '') return false
      // Elimina CPFs invalidos conhecidos
      if (
        cpf.length != 11 ||
        cpf == '00000000000' ||
        cpf == '11111111111' ||
        cpf == '22222222222' ||
        cpf == '33333333333' ||
        cpf == '44444444444' ||
        cpf == '55555555555' ||
        cpf == '66666666666' ||
        cpf == '77777777777' ||
        cpf == '88888888888' ||
        cpf == '99999999999'
      )
        return false
      // Valida 1o digito
      let add = 0
      let rev = 0
      let i
      for (i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i)
      rev = 11 - (add % 11)
      if (rev == 10 || rev == 11) rev = 0
      if (rev != parseInt(cpf.charAt(9))) return false
      // Valida 2o digito
      add = 0
      for (i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i)
      rev = 11 - (add % 11)
      if (rev == 10 || rev == 11) rev = 0
      if (rev != parseInt(cpf.charAt(10))) return false
      return true
    },

    /**
     * Verifica se o recaptcha foi selecionado
     *
     * @param {Object} respone
     */
    onVerify: function (response) {
      if (response) this.robot = true
    },

    /**
     * Limpa os campos do form
     */
    limpaCampos() {
      this.cpf = ''
      this.funcao = ''
      this.cidade = ''
      this.disabledInput = false
      this.temEsusFeedback = null
    },

    /**
     * Manipula a alteração do campo CPF
     *
     * @param {Object} event
     */
    onBlurCpf(event) {
      this.cpf = event.target.value
        .replace('.', '')
        .replace('.', '')
        .replace('-', '')
      this.buscarProfissional()
    },

    /**
     * Busca o profissional
     * */
    async buscarProfissional() {
      this.loading = true
      let funcoesTemProfissional = [
        { value: 'Agente Comunitário de Saúde' },
        { value: 'Aux/Téc Enfermagem' },
        { value: 'Enfermeiro(a)' },
        { value: 'Médico(a)' },
        { value: 'Odontólogo(a)' },
        { value: 'Recepcionista' },
      ]
      let funcoesNaoTemProfissional = [
        { value: 'Gerente/Coordenador(a)' },
        { value: 'Secretário(a)' },
      ]
      this.funcoes = funcoesNaoTemProfissional
      this.nome = ''
      this.funcao = ''
      try {
        let response = await this.$apiPublic.get(
          '/criar-conta/profissional-pec-cnes-datasus/' + this.cpf
        )
        if (response.data.ProfissionalSaude) {
          this.nome = response.data.ProfissionalSaude.Nome.Nome
          let CBO = response.data.ProfissionalSaude.CBO
          let temProfissional = false
          if (CBO.length > 1) {
            temProfissional = true
          } else {
            if (
              CBO.codigoCBO.includes('2251') ||
              CBO.codigoCBO.includes('2252') ||
              CBO.codigoCBO.includes('2253') ||
              CBO.codigoCBO.includes('2231')
            ) {
              this.funcao = 'Médico(a)'
              temProfissional = true
            } else if (CBO.codigoCBO.includes('2235')) {
              this.funcao = 'Enfermeiro(a)'
              temProfissional = true
            } else if (CBO.codigoCBO.includes('3222')) {
              this.funcao = 'Aux/Téc Enfermagem'
              temProfissional = true
            } else if (CBO.codigoCBO.includes('2232')) {
              this.funcao = 'Odontólogo(a)'
              temProfissional = true
            } else if (CBO.codigoCBO.includes('515105')) {
              this.funcao = 'Agente Comunitário de Saúde'
              temProfissional = true
            } else if (CBO.codigoCBO.includes('4221')) {
              this.funcao = 'Recepcionista'
              temProfissional = true
            } else {
              temProfissional = false
              this.funcao = ''
            }
          }
          if (temProfissional) {
            if (CBO.length > 1) {
              this.disabledInput = true
              this.disabledInputFuncao = false
            } else {
              this.disabledInput = true
              this.disabledInputFuncao = true
            }
            this.funcoes = funcoesTemProfissional
            // verifica se existe esus feedback na cidade
            this.$apiPublic
              .get('/faturamento/cidade/' + this.cidade)
              .then((response) => {
                if (response.data == false) {
                  this.temEsusFeedback = false
                } else {
                  this.temEsusFeedback = true
                }
                this.loading = false
              })
              .catch(function (error) {
                console.log(error)
              })
          }
        } else {
          this.disabledInput = false
          this.disabledInputFuncao = false
          this.temEsusFeedback = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula para trocar o avatar
     */
    triggerAvatarSelect() {
      this.$refs.avatarInput && this.$refs.avatarInput.click()
    },

    /**
     * Manipula ao selecionar um avatar
     *
     * @param {File} e
     */
    onAvatarSelected(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return

      // SOMENTE JPG/JPEG/PNG
      const allowed = ['image/jpeg', 'image/png']
      const maxSizeMb = 1

      if (!allowed.includes(file.type)) {
        this.$toast.error('Selecione uma imagem JPG ou PNG.', 'Erro:', {
          position: 'topRight',
        })
        e.target.value = ''
        return
      }

      if (file.size > maxSizeMb * 1024 * 1024) {
        this.$toast.error(
          `A imagem deve ter no máximo ${maxSizeMb}MB.`,
          'Erro:',
          {
            position: 'topRight',
          }
        )
        e.target.value = ''
        return
      }

      this.avatarFile = file

      // preview
      if (this.avatarPreview) URL.revokeObjectURL(this.avatarPreview)
      this.avatarPreview = URL.createObjectURL(file)
    },

    /**
     * Remove o avatar
     */
    removerAvatar() {
      // limpa file
      this.avatarFile = null

      // libera o blob preview anterior
      if (this.avatarPreview) {
        URL.revokeObjectURL(this.avatarPreview)
      }
      this.avatarPreview = null

      // reseta o input file (permite escolher o mesmo arquivo de novo)
      if (this.$refs.avatarInput) {
        this.$refs.avatarInput.value = ''
      }
    },

    /**
     * Cadastra um novo usuário
     */
    async cadastrar() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) return

      if (this.senha !== this.confirmarsenha) {
        this.$toast.error('Erro! As senhas não conferem!', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      if (this.isChecked === '') {
        this.$toast.error('É necessário aceitar os termos de uso.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      if (!this.validarCPF(this.cpf)) {
        this.$toast.error('CPF inválido! Digite um CPF válido.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      if (!this.robot) {
        this.$toast.error('Verificação inválida!', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      this.loading = true

      try {
        const formData = new FormData()
        formData.append('cod_ibge', this.cidade.co_ibge)
        formData.append('nome', this.nome)
        formData.append('data_nascimento', this.data_nascimento)
        formData.append('cpf', this.cpf)
        formData.append('email', this.email)
        formData.append('funcao', this.funcao)
        formData.append('telefone', this.telefone)
        formData.append('senha', this.senha)
        if (this.avatarFile) {
          formData.append('foto_perfil', this.avatarFile)
        }

        const url = '/criar-conta'

        const response = await this.$apiPublic.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (response.data?.error) {
          this.$toast.error(response.data.message, 'Error:', {
            position: 'topRight',
          })
        } else {
          this.$toast.success(response.data.message, 'Sucesso:', {
            position: 'topRight',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
  beforeDestroy() {
    if (this.avatarPreview) URL.revokeObjectURL(this.avatarPreview)
  },
}
</script>

<style scoped>
#criar-conta-parceiro {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px auto;
}
@media screen and (max-width: 656px) {
  #criar-conta-parceiro {
    height: auto;
    margin-bottom: 50px;
  }
}

.card-criar-conta {
  width: 100%;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1.25rem;
  position: relative;
  margin-bottom: 40px;
}

.card-criar-conta i {
  font-size: 20px;
  line-height: 10px;
  text-align: center;
}

.card-criar-conta-title {
  border-bottom: 1px solid #f5f5f5;
  text-align: center;
  margin-bottom: 20px;
}

.card-criar-conta-title h2 {
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-size: 25px;
}

.card-criar-conta .card-icon {
  position: absolute;
  height: 120px;
  width: 120px;
  top: -42px;
  border-radius: 50%;
  background: #f9f9f9;
  padding: 10px;
  text-align: center;
}

.card-criar-conta .v__search {
  color: #495057;
}

.card-criar-conta .vue-select-cidade,
.card-criar-conta .vue-select-estado {
  width: 100%;
}

.error-esus-feedback {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.error-esus-feedback h3,
.error-esus-feedback i {
  font-size: 50px;
}

.error-esus-feedback h4 {
  font-size: 30px;
}

.error-esus-feedback p {
  font-size: 25px;
}

.btn-search-cpf {
  height: 38px;
  border: 1px solid #ccc;
  padding: 0 10px;
}

.links {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
}

.links p {
  text-align: center;
  margin-bottom: 0;
  color: #000;
  font-size: 16px;
}

.links p a {
  margin: 0 auto;
}

.checkbox span {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.avatar-wrapper {
  position: relative;
  width: 110px;
  height: 110px;
  cursor: pointer;
}

.avatar-uploader {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px dashed #cfd6dc;
  background: #f7f9fb;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-uploader:hover {
  border-color: #0d98bb;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #6c757d;
}

.avatar-placeholder i {
  font-size: 32px;
}

.avatar-placeholder small {
  font-size: 12px;
  margin-top: 10px;
}

.avatar-badge {
  position: absolute;
  right: 10px;
  bottom: -4px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #0d98bb;
  color: #fff;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.avatar-badge i {
  font-size: 16px;
}

.avatar-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #dc3545;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
  cursor: pointer;
  padding: 0;
}

.avatar-remove i {
  font-size: 14px;
}

.avatar-remove:hover {
  filter: brightness(0.95);
}
</style>
